import { render, staticRenderFns } from "./MyClasses.vue?vue&type=template&id=c44e0c18&scoped=true&"
import script from "./MyClasses.vue?vue&type=script&lang=ts&"
export * from "./MyClasses.vue?vue&type=script&lang=ts&"
import style0 from "./MyClasses.vue?vue&type=style&index=0&id=c44e0c18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44e0c18",
  null
  
)

export default component.exports